import prp2boxHttp from '../../services/prp2boxHttp'

export interface IRpStand {
  id: number
  name: string
  status: number
  stream: {
    id: string
    name: string
  }
  createdAt: string
  updatedAt: string
}

export interface CreateRpStandPayload extends Pick<IRpStand, 'name' | 'stream'> {}

class Stands {
  prefix: string = '/stands'

  getAll = async (params: {
    limit?: number
    offset?: number
  }): Promise<{
    rows: IRpStand[]
    totalRows: number
  }> => {
    const response = await prp2boxHttp.get(this.prefix, { params })
    return response.data
  }

  getById = async (id: number): Promise<IRpStand> => {
    const response = await prp2boxHttp.get(`${this.prefix}/${id}`)
    return response.data
  }

  create = async (payload: CreateRpStandPayload): Promise<IRpStand> => {
    const response = await prp2boxHttp.post(this.prefix, payload)
    return response.data
  }

  update = async (id: number, payload: CreateRpStandPayload): Promise<IRpStand> => {
    const response = await prp2boxHttp.put(`${this.prefix}/${id}`, payload)
    return response.data
  }
}

export default new Stands()
